/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SaSheetLeaveData { 
    id?: string;
    sheet_id?: string;
    leave_id?: string;
    start?: Date;
    finish?: Date;
    leave_category_id?: string;
    is_salary?: boolean;
    total_hour?: number;
    created_by?: string;
    modified_at?: Date;
    modified_by?: string;
    leave_category_name?: string;
    sheet_staff_id?: string;
    created_at?: Date;
}